/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { ISchemaConstPasswordModel, isSchemaConstPasswordModel } from "@adapptio/lib-blueprint";
import { INSPECTOR_NODE_TYPE, TInspectorNode } from "../InspectorNodeTypes";
import { IInspectorControl_Password, INSPECTOR_CONTROL_TYPE } from "../controls";
import { mapperDescriptor } from "../../modules/Core/ReferenceGuide/mappers/mapperDescriptor";
import { mapperExamples } from "../../modules/Core/ReferenceGuide/mappers/mapperExamples";
import { getParentComponentName } from "../utils";

export function constPasswordMapper(model: ISchemaConstPasswordModel): TInspectorNode {
	if (!isSchemaConstPasswordModel(model)) {
		return;
	}

	const control: IInspectorControl_Password = {
		key: String(model.nodeId),
		type: INSPECTOR_CONTROL_TYPE.PASSWORD,
		model
	};

	return {
		type: INSPECTOR_NODE_TYPE.DEFAULT,
		key: `${model.nodeId}`,
		label: model.schema.opts.label,
		tooltip: model.schema.opts.description,
		default: model.schema.opts.default || null,
		options: model.schema.opts["options"],
		required: model.schema.opts.constraints?.required || false,
		referenceData: getParentComponentName(model),
		descriptor: mapperDescriptor(model.schema),
		examples: mapperExamples(model.schema),
		deps: [ model ],
		controls: [ control ],
		children: []
	};
}
